import Vue from 'vue';
import Router from 'vue-router';
import beforeEach from './BeforeEach';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('@/pages/home'),
      meta: {
        fix: true,
        tit: '首页',
      },
    },
    {
      path: '/fineCourse',
      name: 'fineCourse',
      component: () => import('@/pages/fineCourse'),
      meta: {
        fix: true,
        tit: '精品课程',
      },
    },
    {
      path: '/course',
      name: 'course',
      component: () => import('@/pages/course'),
      meta: {
        fix: true,
        tit: '课程体系',
      },
    },
    {
      path: '/teaching',
      name: 'teaching',
      component: () => import('@/pages/teaching'),
      meta: {
        fix: true,
        tit: '教材体系',
      },
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: () => import('@/pages/teacher'),
      meta: {
        fix: false,
        tit: '外教师资',
      },
    },
    {
      path: '/platform',
      name: 'platform',
      component: () => import('@/pages/platform'),
      meta: {
        fix: false,
        tit: '教学平台',
      },
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: () => import('@/pages/aboutus'),
      meta: {
        fix: false,
        tit: '关于我们',
      },
    },
    {
      path: '/opinion',
      name: 'opinion',
      component: () => import('@/pages/opinion'),
      meta: {
        fix: false,
        tit: '意见反馈',
      },
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import('@/pages/agreement'),
      meta: {
        fix: false,
        tit: '服务协议',
      },
    },
    {
      path: '/agreement-confirm',
      name: 'confirm',
      component: () => import('@/pages/confirm'),
      meta: {
        fix: false,
        tit: '服务协议',
      },
    },
    {
      path: '/teachers',
      name: 'teachers',
      component: () => import('@/pages/teacherList'),
      meta: {
        fix: false,
        tit: '老师列表',
      },
    },
    {
      path: '*',
      redirect: '/home',
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
router.beforeEach(beforeEach);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js